import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { routeMappings } from '../../constants';
import { SessionStore } from '../../constants/sessionStore';
import { Template } from '../../store/interfaces';
import { getTemplateLayout, isJourneyTheme } from '../utils/fallbackCondition';
import { getStore } from '../../store';
import { usePrefersReducedMotion } from '../hooks/usePrefersReducedMotion';

/** Component for implementing scroll to top as history route changes*/
const ScrollToTop = (): React.JSX.Element => {
  const location = useLocation();
  const shouldReduceMotion = usePrefersReducedMotion();

  useEffect(() => {
    const isTaskInitialized = sessionStorage.getItem(SessionStore.isTaskInitialized);
    const onTaskListPage = location.pathname.includes(routeMappings['TASKLIST']);
    const onVideoTaskPage = window.location.hash.includes(routeMappings['EXPVIDEOTASK']);
    const template: Template = getStore().state.template;
    const layout = getTemplateLayout(template.layoutCode);
    if (!(onTaskListPage && isTaskInitialized) && !onVideoTaskPage) {
      if (isJourneyTheme(layout) && !shouldReduceMotion) {
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 1100);
      } else {
        window.scrollTo(0, 0);
      }
    }
  }, [location]);
  return <></>;
};

export default ScrollToTop;
